import PropTypes from "prop-types";

function InfoIcon({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 10 10">
      <path
        d="M1295.867,553.521a5,5,0,1,1-4.989-5.022A5.006,5.006,0,0,1,1295.867,553.521Zm-4.991,3.967a3.989,3.989,0,1,0-4.01-4A3.987,3.987,0,0,0,1290.876,557.488Z"
        transform="translate(-1285.867 -548.499)"
        fill="#454546"
      />
      <path
        d="M1290.876,557.5a4,4,0,1,1,4.006-4.048A4.015,4.015,0,0,1,1290.876,557.5Z"
        transform="translate(-1285.867 -548.499)"
        fill="#fff"
      />
      <g transform="translate(4.507 2.117)">
        <path
          d="M1290.416,551.454a.392.392,0,0,1-.1-.284v-.242a.359.359,0,0,1,.1-.279.4.4,0,0,1,.288-.093h.234a.324.324,0,0,1,.363.372v.242a.41.41,0,0,1-.092.288.351.351,0,0,1-.271.1h-.234A.38.38,0,0,1,1290.416,551.454Zm.15,4.781a.338.338,0,0,1-.09-.251v-3.422a.341.341,0,1,1,.681,0v3.422a.356.356,0,0,1-.591.251Z"
          transform="translate(-1290.315 -550.556)"
          fill="#454546"
        />
      </g>
    </svg>
  );
}

InfoIcon.propTypes = {
  size: PropTypes.number,
};

export default InfoIcon;
